import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { IUser, User } from '../interfaces/user';
import { AuthenticationService } from './authentication.service';
import { PagingService } from './paging.service';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  pagingService = new PagingService<User>();

  emptyUser: User = new User();
  // selectedUser: IUser = this.emptyUser;
  selectedUser$ = new BehaviorSubject<IUser>(null);

  consoPeriod$ = new BehaviorSubject<any>(null);
  consoAdmin$ = new BehaviorSubject<any>(null);
  consoPeriodAdmin = { totalPremium: 0, totalLowcost: 0, moyLowCost: 0, moyPremium: 0 };

  postpaid$ = new BehaviorSubject<any>(null);
  forfait$ = new BehaviorSubject<any>(null);

  constructor(
    private httpClient: HttpClient,
    private authService: AuthenticationService,
  ) {
    this.getCurrentClient();
  }

  getSelectedUser() {
    return this.selectedUser$.getValue();
  }

  clearSelectedUser() {
    this.selectedUser$.next(null)
  }

  getCurrentClient() {
    console.log('user service ctor');
    if (!this.authService.isAdmin) {
      // load user information
      const loggedUser = JSON.parse(sessionStorage.getItem('currentUser'));
      this.GetById(loggedUser.userId).subscribe((user: IUser) => {
        // this.selectedUser = user;
        this.selectedUser$.next(user);
      });
    }
  }

  GetCreditsHistory(clientid, period): Observable<any> {
    return this.httpClient.post(environment.apiUrl + '/clients/credithistory/' + clientid, period).pipe(
      tap((res: any) => {
        if (res.success) {
        this.consoPeriod$.next ( { premium: res.premium, lowcost: res.lowcost });
        }
      }),
      map((res: any) =>  res.history )
    );
  }
  GetCreditsHistoryAll(): Observable<any> {
    return this.consoPeriod$;
  }


  GetCreditsAdminHistory(period): Observable<any> {
    // console.log('GetCreditsAdminHistory');
    return this.httpClient.post(environment.apiUrl + '/credits/adminhistory', period).pipe(
      tap( (res: any) => {
        // console.log(res);
        if (res.success) {
          this.consoPeriod$.next ( {
            totalPremium: res.totalPremium,
            totalLowcost: res.totalLowcost,
            moyLowCost: res.moyLowCost,
            moyPremium: res.moyPremium,
          });
          this.consoAdmin$.next(res.conso);
          }
        }),
      map((res: any) =>  res.credits )
    );
  }
  GetCreditsAdminHistoryPerDay(period): Observable<any> {
    // console.log('GetCreditsAdminHistoryPerDay');
    return this.httpClient.post(environment.apiUrl + '/clients/consoday/adminhistory', period).pipe(
      tap( (res: any) => {
        // console.log(res);
        if (res.success) {
          this.consoPeriod$.next ( {
            totalPremium: res.totalPremium,
            totalLowcost: res.totalLowcost,
            moyLowCost: res.moyLowCost,
            moyPremium: res.moyPremium,
          });
          this.consoAdmin$.next(res.conso);
          }
        }),
      map((res: any) =>  res.consos )
    );
  }

  GetConsoAdmin() {
    return this.consoAdmin$;
  }


  GetCreditsRecap(adminid): Observable<any> {
    return this.httpClient.get(environment.apiUrl + '/credits/adminrecap/' + adminid);
  }

  GetCreditsPostpaid(adminid): Observable<any> {
    return this.httpClient.get(environment.apiUrl + '/credits/adminpostpaid/' + adminid).pipe(
      tap((res: any) => {
        if (res.success) {
          this.postpaid$.next( { totalPremium: res.totalPremium, totalLowcost: res.totalLowcost});
        }
      }),
      map((res: any) =>  res.credits )
    );
  }
  GetPostPaidCounter(): Observable<any> {
    return this.postpaid$;
  }


  SendPostpaidMail(uid, uname): Observable<any> {
    return this.httpClient.post(environment.apiUrl + '/credits/sendpostpaidmail', { userid: uid, username: uname });
  }

  ResetPostpaidCredits(uid, uname): Observable<any> {
    return this.httpClient.post(environment.apiUrl + '/credits/resetcredits', { userid: uid, username: uname });
  }

  GetCreditsForfait(adminid): Observable<any> {
    return this.httpClient.get(environment.apiUrl + '/credits/adminforfait/' + adminid).pipe(
      tap((res: any) => {
        if (res.success) {
          this.forfait$.next( { totalPremium: res.totalPremium, totalLowcost: res.totalLowcost});
        }
      }),
      map((res: any) =>  res.credits )
    );

  }
  GetForfaitCounter(): Observable<any> {
    return this.forfait$;
  }

  SendForfaitMail(uid, uname): Observable<any> {
    return this.httpClient.post(environment.apiUrl + '/credits/sendforfaitmail', { userid: uid, username: uname });
  }

  ResetForfaitCredits(uid, uname): Observable<any> {
    return this.httpClient.post(environment.apiUrl + '/credits/resetforfaitcredits', { userid: uid, username: uname });
  }


  AddAdmin(admin): Observable<any> {
    return this.httpClient.post(environment.apiUrl + '/admins/add', admin);
  }

  UpdateAdmin(admin): Observable<any> {
    return this.httpClient.put(environment.apiUrl + '/admins/update/' + admin.id, admin);
  }

  DeleteAdmin(adminid): Observable<any> {
    return this.httpClient.delete(environment.apiUrl + '/admins/' + adminid);
  }

  GetAdmins(adminid, role): Observable<any> {
    return this.httpClient.post(environment.apiUrl + '/admins/getall', { id: adminid, role });
  }

  GetAll(adminid): Observable<any> {
    return this.httpClient.get(environment.apiUrl + '/clients/getall/' + adminid).pipe(tap((clients: any[]) => {
      clients.forEach( c => {
        c.suspendu = c.disabled === 1 ? 'Oui' : ( c.disabled === 2 ? 'En attente de validation' : '');
      });
    }));
  }

  GetMyClients(id): Observable<any> {
    return this.httpClient.get(environment.apiUrl + '/clients');
  }

  GetById(id) {
    return this.httpClient.get(environment.apiUrl + '/clients/' + id).pipe(
      tap( user => this.selectedUser$.next(user as IUser))
    );
  }

  GetByUsername(username) {
    return this.httpClient.get(environment.apiUrl + '/clients/username/' + username);
  }

  Create(user) {
    return this.httpClient.post(environment.apiUrl + '/clients/create', user);
  }

  Update(isAdmin, user) {
    if (isAdmin)
    return this.httpClient.put(environment.apiUrl + '/clients/admin/' + user.id, user);
    else
    return this.httpClient.put(environment.apiUrl + '/clients/' + user.id, user);
  }

  changePassword(user, password) {
    return this.httpClient.put(environment.apiUrl + '/clients/changepassword/' + user.id, password);
  }

  Delete(user) {
    return this.httpClient.get(environment.apiUrl + '/clients/setdeleted/' + user.id);
  }

  Disable(user, disabled) {
    return this.httpClient.get(environment.apiUrl + '/clients/setdisabled/' + user.id + '/' + disabled);
  }

  DeleteID(userid) {
    return this.httpClient.delete(environment.apiUrl + '/clients/' + userid);
  }


  GetConso(userid, periodlen) {
    return this.httpClient.get(environment.apiUrl + '/clients/conso/' + userid + '/' + periodlen);
  }

  GetModeles(userid, showlast) {
    return this.httpClient.get(environment.apiUrl + '/modeles/user/' + userid + '/' + showlast);
  }

  AddModele(userid, modele) {
    return this.httpClient.post(environment.apiUrl + '/modeles/' + userid, modele);
  }

  UpdateModele(userid, modele) {
    return this.httpClient.put(environment.apiUrl + '/modeles/' + userid, modele);
  }

  DeleteModele(userid, modeleid) {
    return this.httpClient.delete(environment.apiUrl + '/modeles/' + userid + '/' + modeleid);
  }

  GetAliases(userid) {
    return this.httpClient.get(environment.apiUrl + '/aliases/' + userid);
  }

  CheckAlias(userid, modele) {
    return this.httpClient.post(environment.apiUrl + '/aliases/check/' + userid, modele);
  }

  AddAlias(userid, modele) {
    return this.httpClient.post(environment.apiUrl + '/aliases/' + userid, modele);
  }

  UpdateAlias(userid, modele) {
    return this.httpClient.put(environment.apiUrl + '/aliases/' + userid, modele);
  }

  DeleteAlias(userid, modeleid) {
    return this.httpClient.delete(environment.apiUrl + '/aliases/' + userid + '/' + modeleid);
  }


  // -------------------------------------------
  //  for all
  PasswordRequest(username) {
    return this.httpClient.get(environment.apiUrl + '/clients/passwordrequest/' + username);
  }

  VerifyChecksum(username, checksum) {
    return this.httpClient.get(environment.apiUrl + '/clients/verifychecksum/' + username + '/' + checksum);
  }

  Activate(username, checksum) {
    return this.httpClient.get(environment.apiUrl + '/clients/activate/' + username + '/' + checksum);
  }

  ChangeUsernamePassword(username, checksum, password) {
    return this.httpClient.get(environment.apiUrl + '/clients/changepassword/' + username + '/' + checksum + '/' + password);
  }

  Logout() {
    return this.httpClient.get(environment.apiUrl + '/logout');
  }

  adminLogout() {
    return this.httpClient.get(environment.apiUrl + '/adminlogout');
  }


  // -------------------------------------------
  //  add credits  : admin only

  AddCredits(clientid, prio, quantity) {
    return this.httpClient.post(environment.apiUrl + '/clients/credits/' + clientid, { priority: prio, quantity });
  }


}
